<template>
  <div class="side-drawer-container">
    <div class="drawer-button" @click="openSidebar">
      <feather-icon icon="ChevronsLeftIcon" />
      <div class="drawer-button-title">{{ title }}</div>
    </div>
    <div class="side-drawer" :class="{ open: isOpen }">
      <div class="drawer-title">
        {{ title }}
        <feather-icon class="drawer-close" icon="XIcon" @click="closeSidebar" />
      </div>
      <div class="drawer-content">
        <slot />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: "SideDrawer",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    openSidebar() {
      this.isOpen = true;
    },
    closeSidebar() {
      this.isOpen = false;
    },
  },
};
</script>

<style scoped lang="scss">
.side-drawer-container {
  .drawer-button {
    position: fixed;
    top: 95px;
    right: 31px;
    width: 30px;
    display: flex;
    color: white;
    padding: 6px 6px 29px 6px;
    background-color: #64748b;
    writing-mode: vertical-rl;
    align-items: center;
    border-bottom-left-radius: 7px;
    border-top-right-radius: 7px;
    cursor: pointer;
    .drawer-button-title {
      margin-top: 10px;
    }
  }
  .side-drawer {
    height: calc(100% - 84px);
    position: fixed;
    top: 95px;
    right: 0;
    transform: translateX(100%);
    transition: transform 0.3s ease;
    z-index: 1000;
    background-color: #64748b;
    color: white;
    border-top-left-radius: 7px;
    padding: 10px;
    padding-bottom: 40px;
    &.open {
      transform: translateX(0);
    }
    .drawer-title {
      font-size: 16px;
      margin-bottom: 6px;
    }
    .drawer-close {
      position: absolute;
      top: 8px;
      right: 10px;
      cursor: pointer;
    }
    .drawer-content {
      height: 100%;
      overflow-y: auto;
    }
  }
}
</style>
